<template>
  <div class="control-panel"
       :style="{'grid-template-columns': hideRefresh ? 'repeat(6, auto)' : 'auto 151px auto auto auto auto auto'}">
    <content-screen-mode-select @screen="onModeChanged"
                                class="control-panel__screen-mode"/>
    <template v-if="!isSimplifiedView">
      <button v-if="!hideRefresh"
           class="control-panel__refresh-meta"
           @click="refreshMetaData">REFRESH META DATA</button>
      <base-check-box class="control-panel__checkbox" label="Rich snippet"
                    v-model="settings.isReviewVisible"/>
      <span class="control-panel__title">Reviews:</span>
      <base-select  class="control-panel__review-count"
                  :options="reviewOptions"
                  v-model="settings.reviewCount"
                  alignLeft
                  :titleStyle="{'padding-left': '10px'}"
      />
      <span class="control-panel__title">Ratings:</span>
      <star-rating class="control-panel__rating"
                 :increment="0.1"
                 :max-rating="5"
                 inactive-color="#b5c0c9"
                 active-color="#ffb82c"
                 :star-size="15"
                 :show-rating="false"
                 :rating="settings.rating"
                 @rating-selected="setRating"
        />
    </template>
  </div>
</template>

<script>

import StarRating from 'vue-star-rating'
import { mapActions, mapState } from 'vuex'
import ContentScreenModeSelect from './ContentScreenModeSelect'
// eslint-disable-next-line no-unused-vars
import ContentElements from './ContentElements'

const emptySettings = {
  mode: 'desktop',
  rating: 4,
  reviewCount: 50,
  isReviewVisible: false
}
/**
 * Control panel for {@link ContentElements} component.
 * Contains control elements for changing rich snippet
 * It manages UI of recommended SERP
 */
export default {
  name: 'ContentControlPanel',
  components: { ContentScreenModeSelect, StarRating },
  props: {
    predefinedSettings: {
      type: Object,
      default: () => ({})
    },
    hideRefresh: {
      type: Boolean,
      default: false
    },
    isSimplifiedView: Boolean
  },
  created () {
    this.settings = { ...emptySettings, ...this.predefinedSettings }
  },
  data () {
    return {
      settings: {},
      reviewOptions: this.getOptions()
    }
  },
  watch: {
    settings: {
      handler (value) {
        this.$emit('settings', value)
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapState('briefContent', ['briefContent'])
  },
  methods: {
    ...mapActions('briefContent', ['changeContentBrief']),
    setRating (rating) {
      this.settings.rating = rating
    },
    onModeChanged (mode) {
      this.settings.mode = mode
    },
    getOptions () {
      const options = []
      for (let i = 50; i < 3000; i += 50) {
        options.push({ label: i, value: i })
      }
      return options
    },
    async refreshMetaData () {
      const payload = {
        clientId: this.clientId,
        briefId: this.briefContent._id,
        is_refresh_meta_data: true,
        successMessage: 'Meta data refresh has been successfully queued!'
      }
      try {
        await this.changeContentBrief(payload)
      } catch (e) {
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .control-panel {
    display: grid;
    align-items: center;
    font-size: 12px;
    margin-top: 24px;

    &__screen-mode {
      cursor: pointer;
    }

    &__checkbox {
      margin-left: 24px;
    }

    &__refresh-meta {
      margin-left: 24px;
      border: 1px solid rgba(1,22,39,.1);
      border-radius: $rfx-default-border-radius;
      color: $rfx-dark-march;
      background-color: transparent;
      text-align: center;
      width: max-content;
      padding: 13px;
      outline: none !important;
      cursor: pointer;
      font-weight: 900;
      font-size: 10px;

      &:hover {
        background-color: rgba(1,22,39,.1);
      }
    }

    &__title {
      justify-self: end;
      margin-right: 8px;
      margin-left: 24px;
    }

    &__review-count {
      width: 90px;
    }
  }
</style>
